import React, { Fragment, useEffect, useState } from 'react';
import { Row, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import '../estilos.css';
import Navbarh from '../navbar/Navbar';
import MetricasPB from './MetricasPB';
import classnames from 'classnames';
import ResumenOperacion from './ResumenOperacion';


function Metricas() {
    //Declaración de variables        
    const pMetricas = window.$Metricas;
    const [activeTab, setActiveTab] = useState('1');
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    return (
        <>
            <Navbarh />
            {(pMetricas === true) && (
                <Fragment>
                    <div className='margintop20px'>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    onClick={() => { toggle('1'); }}
                                >{/* className={pplaneacion === true || verpplaneacion === true ? "" : "displaynone"} */}
                                    Planeación base
                                </NavLink>
                            </NavItem>
                            <NavItem >
                                <NavLink
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => { toggle('2'); }}
                                >
                                    Procesos
                                </NavLink>
                            </NavItem>
                            <NavItem >
                                <NavLink
                                    className={classnames({ active: activeTab === '3' })}
                                    onClick={() => { toggle('3'); }}
                                >
                                    Embarques
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>

                            <TabPane tabId="1">
                                <MetricasPB />
                            </TabPane>
                            <TabPane tabId="2">
                                <ResumenOperacion />
                            </TabPane>
                            <TabPane tabId="3">
                            </TabPane>
                        </TabContent>
                    </div>
                </Fragment>
            )}
        </>
    )
};



export default Metricas;